import {useEffect} from 'react';
import {useSelector} from 'src/v2/state/store';

type UseStartPollingOnPageLoadParams = {
  startPolling: () => void;
  isPolling: boolean;
};

export const useStartPollingOnPageLoad = ({
  startPolling,
  isPolling,
}: UseStartPollingOnPageLoadParams) => {
  const sessionState = useSelector((state) => state.state);
  const hasSucceededOrProcessingSetupAttempt = useSelector(
    (state) => state.hasSucceededOrProcessingSetupAttempt,
  );

  useEffect(() => {
    if (
      // Payin session blockchain txn has been submitted
      (sessionState === 'purchase_complete' ||
        // Setup session setup attempt has been submitted
        sessionState === 'processing' ||
        // Payin session w/ setup_future_usage setup attempt has been submitted
        (sessionState === 'requires_setup' &&
          hasSucceededOrProcessingSetupAttempt)) &&
      !isPolling
    ) {
      startPolling();
    }
  }, [
    sessionState,
    startPolling,
    isPolling,
    hasSucceededOrProcessingSetupAttempt,
  ]);
};
